import React, {useState} from 'react';
import Input from '../../../../components/input';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/icon';
import Button from '../../../../components/button';

function MyProfileEdit (props) {
	const { t } = useTranslation();
	const {
		data,
		handleCancel,
		handleSave,
		isLoadingProfileChange
	} = props;

	let uniqPhoneId = 0;
	let uniqPostalAddressId = 0;

	let defaultPhoneNumberRows = [{
		"id": "0",
		"label":"",
		"number":""
	}];

	let defaultPostalAddressRows = [{
		"id": "0",
		"label":"",
		"formattedAddress":""
	}];

	if(data.details.phoneNumbers){
		defaultPhoneNumberRows = data.details.phoneNumbers.map(item => {
			uniqPhoneId++;
			return {
				id: uniqPhoneId.toString(),
				...item,
			}
		})
	}

	if(data.details.postalAddress){
		defaultPostalAddressRows = data.details.postalAddress.map(item => {
			uniqPostalAddressId++;
			return {
				id: uniqPostalAddressId.toString(),
				...item,
			}
		})
	}

	const [currentPhoneRows, setCurrentPhoneRows] = useState(defaultPhoneNumberRows);
	const [currentPostalAddressRows, setCurrentPostalAddressRows] = useState(defaultPostalAddressRows);

	const handleNewPhoneRow = () => {
		setCurrentPhoneRows([...currentPhoneRows,
			{
				id: (parseInt(currentPhoneRows[currentPhoneRows.length - 1].id, 10) + 1).toString(),
				label: '',
				number: ''
			}
		]);
	};

	const handleDeletePhoneRow = (e) => {
		setCurrentPhoneRows(currentPhoneRows.filter((phoneNumberRow, index) => parseInt(e.currentTarget.dataset.index, 10) !== index));
	};

	const handleNewPostalAddressRow = () => {
		setCurrentPostalAddressRows([...currentPostalAddressRows,
			{
				id: (parseInt(currentPostalAddressRows[currentPostalAddressRows.length - 1].id, 10) + 1).toString(),
				label: '',
				formattedAddress: ''
			}
		]);
	};

	const handleDeletePostalAddressRow = (e) => {
		setCurrentPostalAddressRows(currentPostalAddressRows.filter((postalAddressRow, index) => parseInt(e.currentTarget.dataset.index, 10) !== index));
	};

	return (
		<div className="col-10">
			<form action="" method="put" autoComplete="off" onSubmit={handleSave}>
				<div className={`row mt-3 pb-2 border-bottom`}>
					<div className="col-md-6">
						<div className="form-group">
							<label htmlFor="myProfileName">{t("textName")}</label>
							<Input
								id="myProfileName"
								defaultValue={data.name}
								placeholder="Name"
								disabled={true}
							/>
						</div>
					</div>
					<div className="col-md-6">
						<div className="form-group">
							<label htmlFor="myProfileEmail">{t("fieldEmail")}</label>
							<Input
								id="myProfileEmail"
								defaultValue={data.email}
								placeholder={t("fieldEmail")}
								disabled={true}
							/>
						</div>
					</div>
				</div>
				<div className={`row mt-3 pb-2 border-bottom`}>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="myProfileJob">{t("fieldJob")}</label>
							<Input
								id="myProfileJob"
								defaultValue={data.details?.job}
								placeholder={t("fieldJob")}
							/>
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="myProfileDepartment">{t("fieldDepartment")}</label>
							<Input
								id="myProfileDepartment"
								defaultValue={data.details?.department}
								placeholder={t("fieldDepartment")}
							/>
						</div>
					</div>
					<div className="col-md-4">
						<div className="form-group">
							<label htmlFor="myProfileCompany">{t("fieldCompany")}</label>
							<Input
								id="myProfileCompany"
								defaultValue={data.details?.company}
								placeholder={t("fieldCompany")}
							/>
						</div>
					</div>
				</div>
				<div className={`row mt-3 pb-2 border-bottom`}>
					<div className="col-md-6">
						<label>{t("fieldPhone")}</label>
						{
							currentPhoneRows.map( (phoneNumber, index) => (
								<div key={phoneNumber.id} className="d-flex form-group my-profile-phone">
									<div className="col-7">
										<Input
											id={`phone-number-${index}`}
											name="phone-number"
											defaultValue={phoneNumber.number}
											placeholder={t("fieldPhone")}
										/>
									</div>
									<div className="col-4">
										<Input
											id={`phone-label-${index}`}
											list={`phone-label-list-${index}`}
											name="phone-label"
											defaultValue={phoneNumber.label}
											placeholder={t("fieldLabelPlaceholder")}
										/>
										<datalist id={`phone-label-list-${index}`}>
											<option value={t("fieldLabelWork")}/>
											<option value={t("fieldLabelHome")}/>
											<option value={t("fieldLabelOther")}/>
										</datalist>
									</div>
									<div className="col-1 d-flex align-items-center">
										{
											index === 0 &&
											<Button className="btn-link p-0 add" onClick={handleNewPhoneRow}>
												<Icon name="plus-circle"/>
											</Button>
										}
										{
											index > 0
												?
												<Button data-index={index} className="btn-link p-0" onClick={handleDeletePhoneRow}>
													<Icon name="times"/>
												</Button>
												:
												null
										}
									</div>
								</div>

							))
						}
					</div>
					<div className="col-md-6">
						<label>{t("fieldPostalAddress")}</label>
						{
							currentPostalAddressRows.map( (postalAddress, index) => (
								<div key={postalAddress.id} className="d-flex form-group my-profile-postal-address">
									<div className="col-7">
										<Input
											id={`postal-address-number-${index}`}
											name="postal-address-formatted-address"
											defaultValue={postalAddress.formattedAddress}
											placeholder={t("fieldPostalAddress")}
										/>
									</div>
									<div className="col-4">
										<Input
											id={`postal-address-label-${index}`}
											list={`postal-address-label-list-${index}`}
											name="postal-address-label"
											defaultValue={postalAddress.label}
											placeholder={t("fieldLabelPlaceholder")}
										/>
										<datalist id={`postal-address-label-list-${index}`}>
											<option value={t("fieldLabelWork")}/>
											<option value={t("fieldLabelHome")}/>
											<option value={t("fieldLabelOther")}/>
										</datalist>
									</div>
									<div className="col-1 d-flex align-items-center">
										{
											index === 0 &&
											<Button className="btn-link p-0 add" onClick={handleNewPostalAddressRow}>
												<Icon name="plus-circle"/>
											</Button>
										}
										{
											index > 0
												?
												<Button data-index={index} className="btn-link p-0" onClick={handleDeletePostalAddressRow}>
													<Icon name="times"/>
												</Button>
												:
												null
										}
									</div>
								</div>

							))
						}

					</div>
				</div>
				<div className={`row mt-3 pb-2 border-bottom`}>
					<div className="col-md-12">
						<div className="form-group">
							<label htmlFor="myProfileBuilding">{t("fieldBuilding")}</label>
							<Input
								id="myProfileBuilding"
								defaultValue={data.details?.building}
								placeholder={t("fieldBuilding")}
							/>
						</div>
					</div>
				</div>
				<div className={`row mt-3 pb-2`}>
					<div className="col-md-12">
						<div className="form-group">
							<label htmlFor="myProfileNotes">{t("fieldDescription")}</label>
							<textarea
								className="form-control"
								name="description"
								id="myProfileNotes"
								rows="2"
								placeholder={t("fieldDescription")}
								defaultValue={data.details?.notes}
							/>
						</div>
					</div>
				</div>
				<div className="text-right mb-3">
					<Button className="btn-secondary" onClick={handleCancel}>
						{t("textCancel")}
					</Button>
					{
						isLoadingProfileChange
						?
							<Button className="ml-3 btn-primary" disabled={true}>
								<Icon animated={'pulse'} name="spinner"/>
							</Button>
						:
							<Button type="submit" className="ml-3 btn-primary">
								{t("textSave")}
							</Button>
					}
				</div>
			</form>
		</div>
	)

}

export default MyProfileEdit;
